import { IconProps } from '../../ui/icons/Icon';
import { css } from '@emotion/css';
import { SvgIcon } from '../../ui/icons/SvgIcon';

export function IconBig(props: IconProps) {
    return (
        <div className={css({ width: '48px', height: '48px' })}>
            <SvgIcon {...props} width={48} height={48} />
        </div>
    );
}
